import NoImage from "assets/images/utility/no_image.png";
import TrellisLink from "components/core/basic/TrellisLink";
import { getURLPrefix } from "utils/getUrlPrefix";
import { css } from "../../../../../styled-system/css";

const URL_PREFIX = getURLPrefix();

export function CategoryCell({
  original,
  buildLink = (category_id: string | number) => `/user/advertising/dashboard/category/${category_id}`,
}: {
  original: {
    category_id: string | number;
    category_name: string;
  };
  buildLink?: (category_id: string | number) => string;
}) {
  const categoryId = original.category_id;
  const image = `${URL_PREFIX}/api/productimage/?category=${categoryId}`;
  return (
    <TrellisLink
      to={buildLink(categoryId)}
      className={css({
        cursor: "pointer",
        display: "flex",
        gap: "small",
        textDecoration: "none",
        fontSize: "1.5rem",
        fontWeight: "700",
      })}
    >
      <div
        className={css({
          flexShrink: 0,
          width: 50,
          height: 50,
          userSelect: "none",
        })}
        style={{
          background: `url(${image}) no-repeat center / contain, url("${NoImage}") no-repeat center / contain`,
        }}
      />
      <div
        className={css({
          fontSize: "medium",
        })}
      >
        {original.category_name}
      </div>
    </TrellisLink>
  );
}
